export enum PhaseType {
  Initial = 'initial',
  Hired = 'hired',
  Normal = 'normal',
  Screening = 'screening',
  Interview = 'interview',
  Assessment = 'assessment',
  Offer = 'offer',
}

export enum ResourceType {
  Candidate = 'candidate',
  Application = 'application',
}

export type Visibility = 'company' | 'personal'

export enum Statuses {
  Created = 'created',
  Pending = 'pending_signature',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Declined = 'declined',
}

export enum Provider {
  JobTarget = 'job_target',
  Join = 'join',
  Vonq = 'vonq',
  LinkedinLimitedListings = 'linkedin_limited_listings',
  WelcomeToTheJungle = 'welcome_to_the_jungle',
  Infojobs = 'infojobs',
}

export enum Status {
  Linked = 'linked',
  InProgress = 'in_progress',
  Live = 'live',
  Offline = 'offline',
  ActionRequired = 'action_required',
  Published = 'published',
  Expired = 'expired',
  Error = 'error',
}
